import React, { useEffect, useMemo } from 'react';
import { Button, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

import { IconMessageCircle } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../../redux-toolkit/store/store";
import { getMyOrdersApi, getMyOrderDetailsApi } from "../../redux-toolkit/slices/orderCreamSlice";
import { formatDateMonthDayYear } from "../../helpers/date";
import { ReactComponent as AssessmentC } from '../../graphics/svgs/assessment-c.svg';
import MiniBodyViewer from "../MiniBodyViewer";

const StageZero = () => {
  // Render active order details
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { orders, singleOrder } = useSelector((state: RootState) => state.orderCream);

  const latestOrder = useMemo(() => {
    if (Array.isArray(orders) && orders.length > 0) {
      return [...orders].sort((a: any, b: any) => {
        const dateA = new Date(a.createdAt).getTime();
        const dateB = new Date(b.createdAt).getTime();
        const validDateA = isNaN(dateA) ? 0 : dateA;
        const validDateB = isNaN(dateB) ? 0 : dateB;
        return validDateB - validDateA;
      })[0];
    }
    return null;
  }, [orders]);

  useEffect(() => {
    dispatch(getMyOrdersApi());
  }, [dispatch]);

  useEffect(() => {
    if (latestOrder) {
      const orderId = latestOrder._id || latestOrder.id;
      if (orderId) {
        dispatch(getMyOrderDetailsApi(`orderId=${orderId}`));
      }
    }
  }, [dispatch, latestOrder]);



  return (
    <div className="w-full h-full flex flex-col">
      {/* Header Section  Start */}
      <div className="mb-6 relative max-w-[800px] mx-auto w-full">
        <div className="flex justify-between items-start">
          <h2 className="text-2xl md:text-3xl font-bold mb-1 text-[var(--theme-text-primary)]" style={{ fontFamily: 'var(--font-h2-fontFamily)', fontWeight: 'var(--font-h2-fontWeight)' }}>Hi {latestOrder?.shippingDetails?.firstName}! Track your order status here.
          </h2>
          <Button 
            size="large"
            className="rounded-lg font-semibold shadow-none flex items-center gap-2 hover:!bg-[var(--primary-500)] hover:!text-white hover:!border-[var(--primary-500)] transition-colors duration-300"
            icon={<IconMessageCircle size={20} />}
            onClick={() => navigate('/chat')}
            style={{ 
              borderColor: 'var(--primary-500)',
              color: 'var(--primary-500)',
              backgroundColor: 'transparent',
              fontFamily: 'var(--font-btn-fontFamily)',
              height: '44px',
              padding: '0 24px',
              fontSize: '14px'
            }}
          >
            Message care team
          </Button>
        </div>
        <div className="flex flex-col gap-0">
                  <div className="mb-4">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                          <Typography 
                            className="h6 text-theme-text-secondary" 
                            style={{ 
                              border: '1px solid var(--neutral-600)',
                              padding: '6px 16px',
                              borderRadius: '9999px',
                              lineHeight: '1',
                              display: 'inline-block',
                              textAlign: 'left'
                            }}
                          >
                            Rx # {latestOrder?.processingDetails?.orderNumber} ordered on {latestOrder?.createdAt ? formatDateMonthDayYear(latestOrder.createdAt) : "December 12, 2025"}
                          </Typography>
                        </div>
                      </div>
        </div>
      </div>
      {/* Header Section  End */}
      
      {/* Stage information content start*/}
      <div 
        className="mx-auto rounded-3xl sm:rounded-[32px] md:rounded-[40px] p-4 sm:p-6 md:p-8 lg:p-12 w-full overflow-hidden relative max-w-[1200px]" 
        style={{ backgroundColor: "var(--neutral-100)" }}
      >
        <div className="flex flex-row items-start gap-6 mb-8">
          <div 
            className="flex-shrink-0 overflow-hidden border-4 border-white shadow-md"
            style={{ width: '96px', height: '96px', borderRadius: '50%' }}
          >
            <AssessmentC style={{ width: '100%', height: '100%' }} />
          </div>
          <div className="flex flex-col justify-center pt-2">
          <h2 className="text-2xl md:text-3xl font-bold mb-1 text-[var(--theme-text-primary)]" style={{ fontFamily: 'var(--font-h2-fontFamily)', fontWeight: 'var(--font-h2-fontWeight)' }}>Show this container if stage REFUND : Your order has been refunded.
          </h2>
            <p className="text-lg text-[var(--theme-text-secondary)] leading-relaxed mb-4 max-w-3xl" style={{ fontFamily: 'var(--font-body1-fontFamily)' }}>
              Please allow approximately 7 days for your refund to be processed.
            </p>
          </div>
        </div>


      </div>
      {/* Stage information content end*/}

    </div>
  );
};

export default StageZero;
